/* istanbul ignore file */
import i18next, { InitOptions } from "i18next";
import HttpApi from "i18next-http-backend";
import { initReactI18next } from "react-i18next";
import { getCommonI18nConfig } from "@questy/aura-cl";
const languageDomNode = document.documentElement;
const i18nVersionNode = document.querySelector("meta[name='i18n_version']");

const i18nVersion = i18nVersionNode && i18nVersionNode.getAttribute("content");
export const language = languageDomNode?.lang;

const i18nConfig: InitOptions = {
  ...getCommonI18nConfig(language, i18nVersion),
};

i18next.use(HttpApi).use(initReactI18next).init(i18nConfig);
